var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"identity-user-edit"},[_c('ToolBar',{attrs:{"to":"/users","title":"Update user"}}),(_vm.identityUser)?_c('EditForm',{attrs:{"user":_vm.identityUser}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }